// extensions/Indent.ts
import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    indent: {
      increaseIndent: () => ReturnType;
      decreaseIndent: () => ReturnType;
    };
  }
}

export const Indent = Extension.create({
  name: "indent",

  addGlobalAttributes() {
    return [
      {
        types: ["paragraph", "listItem"],
        attributes: {
          indent: {
            default: 0,
            parseHTML: (element) => {
              const indent = element.style.marginLeft;

              return indent ? parseInt(indent) / 2 : 0;
            },
            renderHTML: (attributes) => {
              if (!attributes.indent || attributes.indent === 0) return {};

              return {
                style: `margin-left: ${attributes.indent * 2}em`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      increaseIndent:
        () =>
        ({ editor, commands }) => {
          if (editor.isActive("listItem")) {
            return commands.sinkListItem("listItem");
          }

          const { indent = 0 } = editor.getAttributes(editor.state.selection.$from.parent.type.name);

          return commands.updateAttributes(editor.state.selection.$from.parent.type.name, {
            indent: indent + 1,
          });
        },

      decreaseIndent:
        () =>
        ({ commands, editor }) => {
          if (editor.isActive("listItem")) {
            return commands.liftListItem("listItem");
          }

          const { indent = 0 } = editor.getAttributes(editor.state.selection.$from.parent.type.name);
          const newIndent = Math.max(0, indent - 1);

          return commands.updateAttributes(editor.state.selection.$from.parent.type.name, {
            indent: Math.max(0, newIndent),
          });
        },
    };
  },
});

export default Indent;
